module.exports = __webpack_public_path__ + "img/comment-honey.f85f8a56.png";